module.exports = __webpack_public_path__ + "media/images/favicn/apple-touch-icon-f6b622a225a825a87bedbacb62263270.png";